// Social links
var social_links = document.getElementsByClassName('js-socialShare');

// Opens a new window based on a share url stored inside a href
// ------------------------------------------------------
function socialShare(el) {

  // Set values for window
  var intWidth = '500';
  var intHeight = '400';
  var strResize = 'yes';

  // Open a new browser window
  // ------------------------------------------------------
  function openWindow(ev) {
    ev.preventDefault();

    // // Set title and open popup with focus on it
    var strTitle = ((typeof el.getAttribute('title') !== 'undefined') ? el.getAttribute('title') : 'Social Share');
    var strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize;
    var objWindow = window.open(el.getAttribute('href'), strTitle, strParam).focus();
  }

  // Event binding
  // ------------------------------------------------------
  function bindEvents() {
    el.addEventListener('click', openWindow);
  }

  // Kick off
  // ------------------------------------------------------
  bindEvents();
}

// Check of existence and loop over elements
Array.from(social_links || []).forEach(socialShare);
